import CloseButton from "../../../../../components/CloseButton";
import AnalysisSelectionPage from "./analysis/AnalysisSelectionPage";
import ComprehensiveSelectionPage from "./comprehensive/ComprehensiveSelectionPage";
import VocabularySelectionPage from "./vocabulary/VocabularySelectionPage";
import SentenceSelectionPage from "./sentence/SentenceSelectionPage";
import GrammarSelectionPage from "./grammar/GrammarSelectionPage";
import { allTypes } from "../../WorksheetModal/constants";

const TypeSelectionPage = ({
  worksheet,
  onClose,
  onClickNext,
  selectedTypes,
  setSelectedTypes,
}) => {
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fff",
        borderRadius: "10px",
        width: "500px",
        display: "flex",
        paddingBottom: setSelectedTypes === undefined ? "0px" : "60px",
      }}
    >
      {/* 오른쪽 상단 닫기 버튼 */}
      <CloseButton onClick={onClose} />
      {worksheet.type === "analysis" && (
        <AnalysisSelectionPage
          allTypes={allTypes}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
        />
      )}
      {worksheet.type === "comprehensive" && (
        <ComprehensiveSelectionPage
          worksheet={worksheet}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
        />
      )}
      {worksheet.type === "vocabulary" && (
        <VocabularySelectionPage
          worksheet={worksheet}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
        />
      )}
      {worksheet.type === "sentence" && (
        <SentenceSelectionPage
          worksheet={worksheet}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
        />
      )}
      {worksheet.type === "grammar" && (
        <GrammarSelectionPage
          worksheet={worksheet}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
        />
      )}
      {onClickNext && (
        <div
          style={{
            position: "absolute",
            padding: "10px",
            bottom: "0",
            right: "10px",
            display: "flex",
            justifyContent: "right",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <button
            style={{
              padding: "5px 40px",
              backgroundColor: "#2D2D2D",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={onClickNext}
          >
            다음
          </button>
        </div>
      )}
    </div>
  );
};

export default TypeSelectionPage;
